import { EMPTY_STRING } from '../../../constants/common'

import {
  PROFILE_USER_CARD_CONTACT_ICON_MAP,
  PROFILE_USER_CARD_CONTACT_TYPE,
} from './ProfileUserInfoItemCard.constants'

import InformationIcon from '../../../icons/info.svg'

export function getProfileUserCardContactIcon(contactType) {
  return PROFILE_USER_CARD_CONTACT_ICON_MAP[contactType] || InformationIcon
}

export function isProfileUserCardEmailContactType(contactType) {
  return contactType === PROFILE_USER_CARD_CONTACT_TYPE.email
}

export function isProfileUserCardPhoneContactType(contactType) {
  return contactType === PROFILE_USER_CARD_CONTACT_TYPE.phone
}

export function isProfileUserCardCopyableContactType(contactType) {
  return (
    isProfileUserCardEmailContactType(contactType) ||
    isProfileUserCardPhoneContactType(contactType)
  )
}

export function getProfileUserCardContactKey(contact, index) {
  return contact.id || `${contact.type || EMPTY_STRING}-${index}`
}
